import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import Breadcrumb from "../common/breadcrumb";
import { wishlist_actions, cart_actions } from "../../redux-store";

class wishList extends Component {
  changeQty = (e) => {
    this.setState({ quantity: parseInt(e.target.value) });
  };

  render() {
    const {
      items,
      symbol,
      total_price,
      remove_from_wishlist,
      move_from_wishlist_to_cart,
      user,
    } = this.props;

    return (
      <div>
        <Breadcrumb title={"Wishlist"} />
        {items.length > 0 ? (
          <section className="wishlist-section section-b-space">
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <table className="table cart-table table-responsive-xs">
                    <thead>
                      <tr className="table-head">
                        <th scope="col">image</th>
                        <th scope="col">product name</th>
                        <th scope="col">price</th>
                        <th scope="col">availability</th>
                        <th scope="col">action</th>
                      </tr>
                    </thead>
                    {items.map((item, index) => {
                      return (
                        <tbody key={index}>
                          <tr>
                            <td>
                              <Link
                                to={`${process.env.PUBLIC_URL}/product/${item.product._id}`}
                              >
                                <img
                                  src={item?.product.product_images?.[0]?.image}
                                  alt=""
                                />
                              </Link>
                            </td>
                            <td>
                              <Link
                                to={`${process.env.PUBLIC_URL}/product/${item.product._id}`}
                              >
                                {item.product.product_name}
                              </Link>
                              <div className="mobile-cart-content row">
                                <div className="col-xs-3">
                                  <p>in stock</p>
                                </div>
                                <div className="col-xs-3">
                                  <h2 className="td-color">
                                    {symbol}
                                    {item.product.product_price}
                                  </h2>
                                </div>
                                <div className="col-xs-3">
                                  <h2 className="td-color">
                                    <a
                                      href="javascript:void(0)"
                                      className="icon"
                                      onClick={() =>
                                        remove_from_wishlist(
                                          user
                                            ? {
                                                unit: item,
                                              }
                                            : {
                                                product: item.product,
                                              }
                                        )
                                      }
                                    >
                                      <i className="fa fa-times" />
                                    </a>
                                    <a
                                      href="javascript:void(0)"
                                      className="cart"
                                      onClick={() =>
                                        move_from_wishlist_to_cart({
                                          unit: item,
                                        })
                                      }
                                    >
                                      <i className="fa fa-shopping-cart" />
                                    </a>
                                  </h2>
                                </div>
                              </div>
                            </td>
                            <td>
                              <h2>
                                {symbol}
                                {item.product.product_price}
                              </h2>
                            </td>
                            <td>
                              <p>in stock</p>
                            </td>
                            <td>
                              <a
                                href="javascript:void(0)"
                                className="icon"
                                onClick={() =>
                                  remove_from_wishlist(
                                    user
                                      ? {
                                          unit: item,
                                        }
                                      : {
                                          product: item.product,
                                        }
                                  )
                                }
                              >
                                <i className="fa fa-times" />
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="cart"
                                onClick={() =>
                                  move_from_wishlist_to_cart({
                                    unit: item,
                                  })
                                }
                              >
                                <i className="fa fa-shopping-cart" />
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      );
                    })}
                  </table>
                </div>
              </div>
              <div className="row wishlist-buttons">
                <div className="col-12">
                  <Link
                    to={`${process.env.PUBLIC_URL}/merchants`}
                    className="btn btn-solid"
                  >
                    continue shopping
                  </Link>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <section className="cart-section section-b-space">
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <div>
                    <div className="col-sm-12 empty-cart-cls text-center">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/empty-wishlist.png`}
                        className="img-fluid mb-4"
                        alt=""
                      />
                      <h3>
                        <strong>WhishList is Empty</strong>
                      </h3>
                      <h4>Explore more shortlist some items.</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  items: state.wishlist_.items ? state.wishlist_.items : [],
  user: state.auth.user,
  total_price: state.wishlist_.total_price,
  symbol: state.data.symbol,
});
const mapDispatchToProps = (dispatch) => ({
  remove_from_wishlist: (unit) =>
    dispatch(wishlist_actions.remove_from_wishlist(unit)),
  move_from_wishlist_to_cart: (unit) =>
    dispatch(cart_actions.move_from_wishlist_to_cart(unit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(wishList);
